<template>
  <div>
    <header id="page-topbar">
      <div class="navbar-header">
        <div class="d-flex">
          <!-- LOGO -->
          <div class="navbar-brand-box">
            <router-link class="logo logo-dark" to="/">
              <span class="logo-sm">
                <img src="@/assets/images/logo.svg" alt height="32" />
              </span>
              <span class="logo-lg">
                <img src="@/assets/images/logo-dark.png" alt height="27" />
              </span>
            </router-link>

            <router-link class="logo logo-light" to="/">
              <span class="logo-sm">
                <img src="@/assets/images/logo-chevy.png" alt height="32" />
              </span>
              <span class="logo-lg">
                <img src="@/assets/images/logo-light.png" alt height="29" />
              </span>
            </router-link>
          </div>

          <button
            type="button"
            class="btn btn-sm px-3 font-size-16 d-lg-none header-item waves-effect waves-light"
            data-toggle="collapse"
            data-target="#topnav-menu-content"
          >
            <i class="fa fa-fw fa-bars"></i>
          </button>
        </div>
        <!-- <form class="app-search d-none d-lg-block w-50 pr-3">
          <div class="position-relative">
            <input type="text" class="form-control" placeholder="Search..." />
            <span class="bx bx-search-alt"></span>
          </div>
        </form>-->
        <div class="d-flex">
          <div class="dropdown d-inline-block d-lg-none ml-2">
            <button
              type="button"
              class="btn header-item noti-icon waves-effect"
              id="page-header-search-dropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="mdi mdi-magnify"></i>
            </button>
            <div
              class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
              aria-labelledby="page-header-search-dropdown"
            >
              <form class="p-3">
                <div class="form-group m-0">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search ..."
                      aria-label="Recipient's username"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit">
                        <i class="mdi mdi-magnify"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="dropdown d-inline-block">
            <button
              type="button"
              class="btn header-item noti-icon waves-effect"
              id="page-header-notifications-dropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="bx bx-bell bx-tada"></i>
              <span class="badge badge-danger badge-pill" style="right:0">
                <template v-if="getCountNotification > 0">{{ getCountNotification }}</template>
                <template v-else>0</template>
              </span>
            </button>
            <div
              class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
              aria-labelledby="page-header-notifications-dropdown"
            >
              <div class="p-3">
                <div class="row align-items-center">
                  <div class="col">
                    <h6 class="m-0">Notifications</h6>
                  </div>
                  <div class="col-auto">
                    <router-link class="small" :to="{name :'notifications'}">View All</router-link>
                  </div>
                </div>
              </div>
              <div data-simplebar style="max-height: 400px; overflow: auto">
                <template v-if="getLocal.length > 0">
                  <span
                    class="text-reset notification-item"
                    style="cursor: pointer"
                    @click="rdr_srv_t(item.id, item.srv_t_uuid)"
                    v-for="(item, index) in getLocal"
                    :key="index+'-getLocal'"
                  >
                    <div class="media">
                      <div class="avatar-xs mr-3">
                        <span class="avatar-title bg-primary rounded-circle font-size-16">
                          <i class="bx bx-cart"></i>
                        </span>
                      </div>
                      <div class="media-body">
                        <h6 class="mt-0 mb-1">{{ item.label }}</h6>
                        <div class="font-size-12 text-muted">
                          <p class="mb-1">{{ item.description }}</p>
                          <p class="mb-0">
                            <i class="mdi mdi-clock-outline"></i> {{ getDurationNotif(item.date_created) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </span>
                </template>
                <template v-else>
                  <div class="media">                    
                    <p class="font-size-14 btn-block text-center">Data not found</p>
                  </div>
                </template>
              </div>
              <!-- <div class="p-2 border-top">
                <a
                  class="btn btn-sm btn-link font-size-14 btn-block text-center"
                  href="javascript:void(0)"
                >
                  <i class="mdi mdi-arrow-right-circle mr-1"></i> View More..
                </a>
              </div> -->
            </div>
          </div>

          <div class="dropdown d-inline-block">
            <button type="button" class="btn header-item noti-icon right-bar-toggle waves-effect">
              <i class="bx bx-cog bx-spin"></i>
            </button>
          </div>

          <div class="dropdown d-inline-block">
            <button
              type="button"
              class="btn header-item waves-effect"
              id="page-header-user-dropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <template v-if="users.usr_photo !== null && users.usr_photo !== ''">
                <img
                  class="rounded-circle header-profile-user"
                  :src="$root.backEnd+'/'+users.usr_photo"
                  alt="Header Avatar"
                />
              </template>
              <template v-else>
                <img
                  class="rounded-circle header-profile-user"
                  src="@/assets/images/users.png"
                  alt="Header Avatar"
                />
              </template>
              <span class="d-none d-xl-inline-block ml-1">{{users.usr_fullname}}</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <!-- item-->
              <router-link class="dropdown-item" :to="{name:'profile'}">
                <i class="bx bx-user font-size-16 align-middle mr-1"></i>
                Profile
              </router-link>
              <a class="dropdown-item d-block" href="#">
                <span class="badge badge-success float-right">11</span>
                <i class="bx bx-wrench font-size-16 align-middle mr-1"></i> Settings
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-danger" href="javascript:;" @click="logout">
                <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i> Logout
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="topnav">
      <div class="container-fluid">
        <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
          <div class="collapse navbar-collapse" id="topnav-menu-content">
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link
                  :class="'nav-link '+activetRoute('dashboards')"
                  :to="{name:'dashboards'}"
                >
                  <i class="bx bx-home-circle mr-2"></i>Dashboard
                </router-link>
              </li>
              <li class="nav-item dropdown">
                <a
                  :class="'nav-link dropdown-toggle arrow-none '+activetRoute('services')"
                  href="#"
                  id="topnav-pages"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="bx bx-note mr-2"></i>Servis
                  <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-pages">
                  <router-link class="dropdown-item" :to="{name :'services'}">Servis</router-link>
                  <router-link class="dropdown-item" :to="{name :'services_bulk'}">Paket Servis</router-link>
                  <router-link
                    class="dropdown-item"
                    :to="{name :'services_transaction'}"
                  >Transaksi Servis</router-link>
                  <router-link class="dropdown-item" :to="{name :'supplier'}">Supplier</router-link>
                </div>
              </li>

              <li class="nav-item dropdown">
                <a
                  :class="'nav-link dropdown-toggle arrow-none '+activetRoute('cars')"
                  href="#"
                  id="topnav-pages"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="bx bx-car mr-2"></i>Mobil
                  <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-pages">
                  <router-link class="dropdown-item" :to="{name :'cars_brand'}">Brand Mobil</router-link>
                  <router-link class="dropdown-item" :to="{name :'cars_model'}">Tipe Mobil</router-link>
                </div>
              </li>
              <li class="nav-item dropdown">
                <a
                  :class="'nav-link dropdown-toggle arrow-none '+activetRoute('products')"
                  href="#"
                  id="topnav-pages"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="bx bx-box mr-2"></i>Produk
                  <span v-if="pendingCount > 0" class="badge badge-danger ml-1">{{ pendingCount }}</span>
                  <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-pages">
                  <router-link class="dropdown-item" :to="{name :'brand'}">Brand</router-link>
                  <router-link class="dropdown-item" :to="{name :'products'}">Produk</router-link>
                  <router-link class="dropdown-item" :to="{name :'products_category'}">Part Kategori</router-link>
                  <router-link class="dropdown-item" :to="{name :'pembelian_produk'}">Pembelian Produk</router-link>
                  <router-link class="dropdown-item" :to="{name :'product_orders'}">
                    Pembelian Customer
                    <span v-if="pendingCount > 0" class="badge badge-danger ml-auto">{{ pendingCount }}</span>
                  </router-link>
                  <router-link class="dropdown-item" :to="{name :'stock_opname'}">Stock Opname</router-link>
                </div>
              </li>

              <li class="nav-item dropdown">
                <a
                  :class="'nav-link dropdown-toggle arrow-none '+activetRoute('users')"
                  href="#"
                  id="topnav-pages"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="bx bx-user mr-2"></i>User
                  <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-pages">
                  <router-link class="dropdown-item" :to="{name :'admin'}">Admin</router-link>
                  <router-link class="dropdown-item" :to="{name :'customers'}">Pelanggan</router-link>
                </div>
              </li>

              <li class="nav-item dropdown">
                <a
                  :class="'nav-link dropdown-toggle arrow-none '+activetRoute('setting')"
                  href="#"
                  id="topnav-pages"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="bx bx-cog mr-2"></i>Setting
                  <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-pages">
                  <router-link class="dropdown-item" :to="{name :'divisi'}">Divisi</router-link>
                  <router-link class="dropdown-item" :to="{name :'employee'}">Karyawan</router-link>
                  <router-link class="dropdown-item" :to="{name :'store'}">Toko</router-link>
                  <router-link class="dropdown-item" :to="{name :'day_off'}">Hari Libur</router-link>
                  <div class="dropdown-divider"></div>
                  <router-link class="dropdown-item" :to="{name :'bank_accounts'}">Bank Accounts</router-link>
                </div>
              </li>
              <li class="nav-item dropdown" v-if="users.usr_admin == 1">
                <a
                  :class="'nav-link dropdown-toggle arrow-none '+activetRoute('target')"
                  href="#"
                  id="topnav-pages"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="bx bx-user mr-2"></i>Payroll
                  <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-pages">
                  <router-link class="dropdown-item" :to="{name :'target'}">Target</router-link>
                  <!-- <router-link class="dropdown-item" :to="{name :'kasbon'}">Kasbon</router-link> -->
                  <router-link class="dropdown-item" :to="{name :'payroll'}">Payroll</router-link>
                </div>
              </li>
              <li class="nav-item dropdown">
                <a
                  :class="'nav-link dropdown-toggle arrow-none '+activetRoute('custom')"
                  href="#"
                  id="topnav-pages"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="bx bx-plus mr-2"></i>Tambahan
                  <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-pages">
                  <router-link class="dropdown-item" :to="{name :'blog'}">Blog</router-link>
                  <router-link class="dropdown-item" :to="{name :'troubleshoot'}">Permasalahan</router-link>
                  <a href="https://crmv5.barantum.com/barantumchat" target="_blank" class="dropdown-item">Chat</a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pendingCount: 0,
      pollInterval: null,
    };
  },
  mounted() {
    this.$root.getNotificationUnread();
    this.checkPendingOrders();
    this.pollInterval = setInterval(() => this.checkPendingOrders(), 30000);
  },
  beforeDestroy() {
    if (this.pollInterval) clearInterval(this.pollInterval);
  },
  computed: {
    users() {
      if (localStorage.getItem("users") != undefined) {
        return JSON.parse(localStorage.getItem("users"));
      }
      return {};
    },
    getLocal() {
      if (typeof this.$root.notification_unread.notification !== 'undefined') {
        return this.$root.notification_unread.notification.data;        
      }
      return []
    },
    getCountNotification(){
      if (typeof this.$root.notification_unread.notification !== 'undefined') {
        return parseInt(this.$root.notification_unread.notification.total_data);        
      }
      return 0
    }
  },
  methods: {
    checkPendingOrders() {
      const s0 = this.axios.get('/product-purchase/admin/orders?show=1&status=0');
      const s2 = this.axios.get('/product-purchase/admin/orders?show=1&status=2');
      Promise.all([s0, s2])
        .then(([r0, r2]) => {
          const c0 = r0.data?.data?.total_data || 0;
          const c2 = r2.data?.data?.total_data || 0;
          this.pendingCount = c0 + c2;
        })
        .catch(() => {});
    },
    logout() {
      this.axios.get("/users/logout").then((response) => {
        if (response.data != undefined) {
          localStorage.removeItem("token");
          localStorage.removeItem("users");
          this.$router.push({ name: "Login" });
        }
        // router.push({ name: 'user', params: { userId: 123 }})
      });
    },
    activetRoute(arm) {
      var res = "";
      var rName = this.$route.name;

      var ser = rName.slice(0, 8);
      var cars = rName.slice(0, 4);
      var prod = rName.slice(0, 8);
      var str = rName.slice(0, 5);
      var div = rName.slice(0, 6);
      var brd = rName.slice(0, 5);
      var emp = rName.slice(0, 8);
      var adm = rName.slice(0, 5);
      var cst = rName.slice(0, 9);

      if (rName == arm) {
        res = "active";
      }

      if (arm == ser) {
        res = "active";
      } else if (arm == cars) {
        res = "active";
      } else if (arm == prod) {
        res = "active";
      } else if (arm == str) {
        res = "active";
      } else if (arm == div) {
        res = "active";
      } else if (arm == emp) {
        res = "active";
      } else if (arm == "products" && brd == "brand") {
        res = "active";
      } else if (arm == "divisi" && emp == "employee" && emp == "troubleshoot") {
        res = "active";
      } else if (arm == "users" && (adm == "admin" || cst == "customers")) {
        res = "active";
      }

      return res;
    },
    getDurationNotif(date){
      var date_now = this.$moment();//now
      var date_end = this.$moment(date);
      return date_end.from(date_now) 
    },
    rdr_srv_t(id, uuid){
      let param = {
        id : id
      }

      this.axios.post("notification/update_read_admin", param).then((response) => {
        this.$root.getNotificationUnread();
        if (response.data != undefined) {
          this.$router.push({
            name: "services_transaction_detail",
            params: { uuid: uuid }
          });
        }
      });

      
    }
  },
};
</script>